import defineComponent from 'flight';

import 'static/style/utils/read-more-text-box';

/**
  Usage:
  
    HTML:
    <div class="crp-intro-text read-more-text-box read-more-text-box--fade" data-read-more-text-box>
        <div>
            Long text that may not fit.
        </div>
        <div class="read-more-text-box__gradient position-absolute text-center text-md-left m-0 w-100 show" data-read-more-text-box-gradient>
             <button class="btn btn-sm btn-outline-primary" data-read-more-text-box-button>Read more</button>
        </div>
    </div>

 */
function ReadMoreTextBox() {
    this.attributes({
        readMoreGradientBox: '[data-read-more-text-box-gradient]',
        readMoreButton: '[data-read-more-text-box-button]'
    });

    this._onClickShow = function(e) {
        e.preventDefault();
        e.stopPropagation();
        this._show();
    };

    this._show = function() {
        this.select('readMoreGradientBox').removeClass('show');
        this.$node.removeClass('read-more-text-box--fade');
    };

    this._isContentVisible = function() {
        return this.node.offsetHeight + 1 >= this.node.scrollHeight; // added 1 for problems with scrollHeight calculation in IE11 and EDGE
    };

    this.after('initialize', function() {
        if (this._isContentVisible()) {
            this._show();
        } else {
            this.on('click', { readMoreButton: this._onClickShow });
            this.select('readMoreGradientBox').addClass('show');
        }
    });
}

export default defineComponent.component(ReadMoreTextBox);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/read-more-text-box.js